import type { QTableColumn } from 'quasar';
import { formatDate } from 'src/utils/formatDate';
export interface BulkOperationModelInput {
  id: string;
  type: string;
  status: string;
  executor: string;
  executor_name: string;
  started_at: string;
  finished_at: string;
  file_name: string;
  create: number;
  update: number;
  delete: number;
  nochange: number;
  errors: number;
  total: number;
  msgs: string[];
}
export interface BulkOperationGetAttributes {
  id: string;
  type: string;
  status: string;
  executor: string;
  executor_name: string;
  started_at: string;
  finished_at: string;
  file_name: string;
  create: number;
  update: number;
  delete: number;
  nochange: number;
  errors: number;
  total: number;
  msgs: string[];
}
export class BulkOperationModel {
  id: string;
  type: string;
  status: string;
  executor: string;
  executor_name: string;
  started_at: string;
  finished_at: string;
  file_name: string;
  create: number;
  update: number;
  delete: number;
  nochange: number;
  errors: number;
  total: number;
  msgs: string[];

  constructor(input?: BulkOperationModelInput) {
    this.id = input ? input.id : '';
    this.type = input ? input.type : '';
    this.status = input ? input.status : '';
    this.executor = input ? input.executor : '';
    this.executor_name = input ? input.executor_name : '';
    this.started_at = input ? formatDate(input.started_at) : '';
    this.finished_at = input
      ? input.finished_at != undefined
        ? formatDate(input.finished_at)
        : ''
      : '';
    this.file_name = input ? input.file_name : '';
    this.create = input ? input.create : 0;
    this.update = input ? input.update : 0;
    this.delete = input ? input.delete : 0;
    this.nochange = input ? input.nochange : 0;
    this.errors = input ? input.errors : 0;
    this.total = input ? input.total : 0;
    this.msgs = input ? input.msgs : [];
  }

  getId(): string {
    return this.id;
  }
  getAttributes(): BulkOperationGetAttributes {
    return {
      id: this.id,
      type: this.type,
      status: this.status,
      executor: this.executor,
      executor_name: this.executor_name,
      started_at: this.started_at,
      finished_at: this.finished_at,
      file_name: this.file_name,
      create: this.create,
      update: this.update,
      delete: this.delete,
      nochange: this.nochange,
      errors: this.errors,
      total: this.total,
      msgs: this.msgs,
    };
  }
}
export type BulkOperationCollection = BulkOperationModel[];
export const BulkOperationTableColumns: QTableColumn[] = [
  {
    name: 'type',
    label: '一括操作',
    align: 'left',
    field: 'type',
    sortable: false,
  },
  {
    name: 'status',
    label: 'ステータス',
    align: 'left',
    field: 'status',
    sortable: false,
  },
  {
    name: 'executor_name',
    label: '実行者名',
    align: 'left',
    field: 'executor_name',
    sortable: false,
  },
  {
    name: 'started_at',
    label: '開始日時',
    align: 'left',
    field: 'started_at',
    sortable: false,
  },
  {
    name: 'finished_at',
    label: '終了日時',
    align: 'left',
    field: 'finished_at',
    sortable: false,
  },
  {
    name: 'file_name',
    align: 'left',
    label: 'ファイル名',
    field: 'file_name',
    sortable: false,
  },
];
